import { render, staticRenderFns } from "./NoteDetailsAttachmentList.vue?vue&type=template&id=3c63ed70&scoped=true&"
import script from "./NoteDetailsAttachmentList.vue?vue&type=script&lang=js&"
export * from "./NoteDetailsAttachmentList.vue?vue&type=script&lang=js&"
import style0 from "./NoteDetailsAttachmentList.vue?vue&type=style&index=0&id=3c63ed70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c63ed70",
  null
  
)

export default component.exports